module.exports = __webpack_public_path__ + "img/add-new-marketing-member-blue.a20835e1.svg";